import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { IpLocationService } from 'app/wipperoz-core/services/ip-location.service';
import { WipperozGeolocationService } from 'app/wipperoz-core/services/location.service';
import { IpLocation } from 'app/wipperoz-core/types/location/ip-location.model';
import { environment } from 'environments/environment';

import { Product } from 'app/wipperoz-core/types/pricing/product.model';
import { PricingService } from 'app/services/pricing.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit, OnDestroy {
  products: Product[] = [];

  urlSignUp = `${environment.appUrl}/auth/signup`;
  private unsubscribeAll: Subject<any>;

  constructor(
    private pricingService: PricingService,
    private ipLocationService: IpLocationService,
    private locationService: WipperozGeolocationService
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    if (this.pricingService.products === undefined || this.pricingService.products.length === 0) {
      if (this.ipLocationService.ipLocationChanged !== undefined) {
        this.ipLocationService.ipLocationChanged
          .pipe(
            takeUntil(this.unsubscribeAll),
            filter((x: any) => {
              return x !== undefined && x.items !== undefined;
            })
          )
          .subscribe((data) => {
            const ipLocation = new IpLocation(data.items[0]);
            if (ipLocation.currencyCode !== undefined) {
              this.pricingService.getPlans().then((data) => {
                if (data !== null) {
                  this.products = data.sort((a, b) => {
                    return a.metadata.position - b.metadata.position;
                  });
                }
              });
            }
          });
      }
    } else {
      if (this.pricingService.products !== undefined || this.pricingService.products.length > 0) {
        this.products = this.pricingService.products;
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
